// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-container[data-v-c5a1803e]{position:relative;height:100%;padding-top:60px;box-sizing:border-box}.user-container .user-main[data-v-c5a1803e]{position:relative;display:flex;justify-content:space-between;height:100%;overflow:hidden}", ""]);
// Exports
module.exports = exports;
